import React, { useState, useRef, useEffect } from 'react'
import moment from 'moment';
import { CustomerAddress, LeadModel, SimulatorOfferModel, AuthorizedToDrive, VehicleDataModel, RiderPackageModel, LeadRider, YesNo } from '../models/superbit-api-models';
import { RenewalsModel } from '../models/RenewalsModel';
import { SimulatorData, SimulatorModel } from '../models/SimulatorModel';
import { AutocompleteData, getNameByIdInIDNameDescriptionDictionary, IDNameDescriptionDictionary } from '../models/Site';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { DynamicSelect } from '../components/_DynamicSelect';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { off } from 'process';
import Address from '../Adrress/_Address';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { last, set } from 'lodash';
import { Autocomplete } from '../components/_Autocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import "./Renewal.css";
import { OfferRider } from '../offers/_OfferRider';

class VehicleDetailsData {
    tozeretCd?: number;
    degemCd?: number;
    manufacturerId?: string;
    manufacturer?: string;
    vehicleModelId?: string;
    vehicleModel?: string;
    vehicleSubModelId?: string;
    vehicleSubModel?: string;
    modelCode?: string;
    carYear?: number;
};

interface RenewalOfferPopupProps {
    renewalId: string;
    closePopup: Function;
}


const RenewalOfferPopup: React.FC<RenewalOfferPopupProps> = ({
    renewalId,
    closePopup
}) => {
    const startDateRef = useRef<DatePicker>(null);
    const driverYoungAgeRef = useRef<DatePicker>(null);
    const driverMainAgeRef = useRef<DatePicker>(null);
    const driverYoungSeniorityDateRef = useRef<DatePicker>(null);
    const driverMainSeniorityDateRef = useRef<DatePicker>(null);
    const entryToRoadDateRef = useRef<DatePicker>(null);

    const renewalsModel: RenewalsModel = new RenewalsModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const [renewal, setRenewal] = useState<LeadModel | "">("");
    const [offer, setOffer] = useState<SimulatorOfferModel>(new SimulatorOfferModel());
    const [InsuranceTypes, setInsuranceTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [AuthorizedToDriveList, setAuthorizedToDriveList] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [Geder, setGeder] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [PassedTypeOfInsurance, setPassedTypeOfInsurance] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [MaritalStatus, setMaritalStatus] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [VehicleOwnership, setVehicleOwnership] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [ImpairmentDeductible, setImpairmentDeductible] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [RenovationAgentsOffice, setRenovationAgentsOffice] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [RenovationCompany, setRenovationCompany] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [citiesAutocomplete, setCitiesAutocomplete] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [vehicleDetailsError, setVehicleDetailsError] = useState<string>("");
    const [entryToRoadDateError, setEntryToRoadDateError] = useState<string>("");
    const [manufacturerError, setManufacturerError] = useState<string>("");
    const [vehicleModelError, setVehicleModelError] = useState<string>("");
    const [vehicleSubModelError, setVehicleSubModelError] = useState<string>("");
    const [lastLicense, setLastLicense] = useState<string>("");
    const [licenseNumberLoading, setLicenseNumberLoading] = useState<boolean>(false);
    const [vehicleDetails, setVehicleDetails] = useState<VehicleDetailsData | undefined>(undefined);
    const [missingVehicleDetails, setMissingVehicleDetails] = useState<boolean>(false);
    const [showVehicleDetails, setShowVehicleDetails] = useState<boolean>(false);
    const [ModelcodeAutocomplete, setModelcodeAutocomplete] = useState<[]>([]);
    const [modelCode, setModelCode] = useState<string>("");
    const [codeModelLoading, setCodeModelLoading] = useState<boolean>(false);
    const [lastmodelCode, setLastmodelCode] = useState<string>("");
    const [CarYear, setCarYear] = useState<Array<string>>([]);

    const [ManufacturerAll, setManufacturerAll] = useState<Array<AutocompleteData>>([]);
    const [ManufacturerAutocomplete, setManufacturerAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [VehicleModelAutocomplete, setVehicleModelAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [VehicleModelAll, setVehicleModelAll] = useState<Array<AutocompleteData>>([]);
    const [VehicleSubModelAutocomplete, setVehicleSubModelAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [VehicleSubModelAll, setVehicleSubModelAll] = useState<Array<AutocompleteData>>([]);
    const [manufacturer, setManufacturer] = useState<string>("");
    const [vehicleModel, setVehicleModel] = useState<string>("");
    const [vehicleModelId, setVehicleModelId] = useState<string>("");
    const [vehicleSubModel, setVehicleSubModel] = useState<string>("");
    const [vehicleSubModelId, setVehicleSubModelId] = useState<string>("");
    const [showVehiclePopup, setShowVehiclePopup] = useState<boolean>(false);
    const [riderPackages, setRiderPackages] = useState<RiderPackageModel[]>([]);
    const [policyRiderPackages, setPolicyRiderPackages] = useState<RiderPackageModel[]>([]);
    useEffect(() => {
        load();
    }, [])


    useEffect(() => {
        if (!vehicleDetails)
            getVehicleDetails();
    }, [offer]);

    const load = async () => {
        renewalsModel.renewalGetAllDetails(renewalId).then((res) => {
            setRenewal(res);
            setOffer(res.offers.find((o: SimulatorOfferModel) => o.renewalsOffer === true));

            if (res.vehicleId) {
                renewalsModel.getRiders(res.vehicleId).then((riderRes: any) => {
                    setRiderPackages(riderRes);
                });

            }

            if (res.policy?.policyAdditionDetails?.vehicleId) {
                renewalsModel.getRiders(res.policy?.policyAdditionDetails?.vehicleId).then((riderRes: any) => {
                    riderRes = riderRes
                        .map((rider: RiderPackageModel) => {
                            const rp = res.policy?.policyAdditionDetails?.rider?.riderPackages
                                ?.find((rp: any) => rp.riderPackageId === rider.id);

                            if (rp) {
                                return {
                                    ...rider,
                                    recommendedCost: rp.customerCost
                                };
                            }

                            return null;
                        })
                        .filter((rider: any): rider is RiderPackageModel => rider !== null);


                    setPolicyRiderPackages(riderRes);
                });
            }

        });



        simulatorModel.getInsuranceTypes().then((res: any) => {
            setInsuranceTypes(res);
        });

        simulatorModel.getAuthorizedToDriveItems().then((res: any) => {
            setAuthorizedToDriveList(res);
        });

        simulatorModel.getGenderTypes().then((res: any) => {
            setGeder(res);
        });

        simulatorModel.getPassedTypeOfInsurance().then((res: any) => {
            setPassedTypeOfInsurance(res);
        });

        simulatorModel.getMaritalStatus().then((res: any) => {
            setMaritalStatus(res);
        });

        simulatorModel.getVehicleOwnership().then((res: any) => {
            setVehicleOwnership(res);
        });

        simulatorModel.getImpairmentDeductible().then((res: any) => {
            setImpairmentDeductible(res);
        });

        simulatorModel.getRenovationAgentsOffice().then((res: any) => {
            setRenovationAgentsOffice(res);
        });

        simulatorModel.getRenovationCompany().then((res: any) => {
            setRenovationCompany(res);
        });

        // simulatorModel.getCitiesAutocomplete().then((res: any) => {
        //     setCitiesAutocomplete(res);
        // });

        var _CarYear = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            _CarYear.push(i + "");
        }
        setCarYear(_CarYear);

        setManufacturerAll(await new SimulatorModel().getManufacturers());
    }

    const saveOffer = async () => {
        if (renewal === "") return;

        const normalizedObj = new SimulatorOfferModel(offer);
        normalizedObj.createdDate = offer.createdDate ? new Date(offer.createdDate) : new Date();
        normalizedObj.updatedDate = offer.updatedDate ? new Date(offer.updatedDate) : new Date();
        normalizedObj.startDate = offer.startDate ? new Date(offer.startDate) : new Date();
        normalizedObj.endDate = offer.endDate ? new Date(offer.endDate) : new Date();

        normalizedObj.driverYoungBirthDate = offer.driverYoungBirthDate ? new Date(offer.driverYoungBirthDate) : new Date();
        normalizedObj.driverMainSeniorityDate = offer.driverMainSeniorityDate ? new Date(offer.driverMainSeniorityDate) : new Date();
        normalizedObj.driverMainBirthDate = offer.driverMainBirthDate ? new Date(offer.driverMainBirthDate) : new Date();
        normalizedObj.driverYoungSeniorityDate = offer.driverYoungSeniorityDate ? new Date(offer.driverYoungSeniorityDate) : new Date();
        normalizedObj.driverMainSeniorityDate = offer.driverMainSeniorityDate ? new Date(offer.driverMainSeniorityDate) : new Date();
        await renewalsModel.renewalUpsertOffer(normalizedObj);
        closePopup();
    }

    const setRenewalData = (name: keyof LeadModel, value: any) => {
        setRenewal(prev => {
            if (prev === "") return prev;

            // Create a new instance of the class using the previous data
            const updated = new LeadModel(prev);

            (updated as any)[name] = value;

            return updated;
        });
    };

    const setOfferData = (name: keyof SimulatorOfferModel, value: any) => {
        setOffer(prev => {

            // Create a new instance of the class using the previous data
            const updated = new SimulatorOfferModel(prev);

            (updated as any)[name] = value;

            return updated;
        });
    };
    const setAuthorizedToDrive = async (name: string, value: any) => {

        setOffer(prev => {

            // Create a new instance of the class using the previous data
            const data = new SimulatorOfferModel(prev);

            data.authorizedToDrive = value;
            data.driverYoungAge = 24;
            data.driverYoungBirthDate = data.startDate ? addYears(data.startDate, -24) : undefined;
            data.driverYoungSeniority = 6;
            data.driverYoungSeniorityDate = data.startDate ? addYears(data.startDate, -6) : undefined;
            data.driverMainAge = 24;
            data.driverMainBirthDate = data.startDate ? addYears(data.startDate, -24) : undefined;
            data.driverMainSeniority = 6;
            data.driverMainSeniorityDate = data.startDate ? addYears(data.startDate, -6) : undefined;


            return data;
        });
    }

    const addYears = (date: Date, years: number): Date => {
        const newDate = new Date(date);
        newDate.setFullYear(newDate.getFullYear() + years);
        return newDate;
    };


    const calcEndDate = () => {
        if (offer != null && offer.startDate) {
            var endDate = getCalcEndDateByStartDate(new Date(offer.startDate));
            setOfferData("endDate", endDate);

        }


    }
    const getCalcEndDateByStartDate = (startDate: Date) => {
        // 
        if (startDate != null) {
            var month = startDate.getMonth();
            var year = startDate.getFullYear();
            if (startDate.getDate() > 15) {
                month++;
                if (month == 13) {
                    month = 1;
                    year++;
                }

            }
            var endDate = new Date(year + 1, month, 1, 0, 0, 0, 0);
            endDate.setDate(endDate.getDate() - 1);
            return endDate;

        }
        return new Date();
    }

    const changeAddress = (address: CustomerAddress) => {

        setOffer(prev => {

            const updated = new SimulatorOfferModel(prev);

            updated.involvedAddress = address;

            return updated;
        });
    }

    const calculateAge = (birthday: Date): number => {
        var simData = offer;
        if (simData == null || simData.startDate == null) return 0;
        let timeDiff = Math.abs(new Date(simData.startDate).getTime() - birthday.getTime());
        return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    }

    const setDriverDate = (name: string, value: any) => {
        debugger;
        var age = calculateAge(value);
        if (name == "driverYoungBirthDate") {
            setOfferData("driverYoungAge", age);

            if (offer != null && offer.authorizedToDrive == AuthorizedToDrive._2) {
                setOfferData("driverMainAge", age);
                setOfferData("driverMainBirthDate", value);
            }

        }
        else if (name == "driverMainBirthDate") {
            setOfferData("driverMainAge", age);

        }
        else if (name == "driverYoungSeniorityDate") {
            setOfferData("driverYoungSeniority", age);
            if (offer != null && offer.authorizedToDrive == AuthorizedToDrive._2) {
                setOfferData("driverMainSeniority", age);
                setOfferData("driverMainSeniorityDate", value);
            }
        }
        else if (name == "driverMainSeniorityDate") {
            setOfferData("driverMainSeniority", age);

        }

    }

    const setDriverAge = (name: string, event: any) => {
        setOffer(prev => {

            const _offer = new SimulatorOfferModel(prev);
            switch (name) {
                case "driverYoungAge": {
                    var startDate = _offer.startDate != null ? _offer.startDate : new Date();
                    _offer.driverYoungAge = parseInt(event.target.value);
                    _offer.driverYoungBirthDate = addYears(startDate, -_offer.driverYoungAge);
                    break;
                }
                case "driverMainAge": {
                    var startDate = _offer.startDate != null ? _offer.startDate : new Date();
                    _offer.driverMainAge = parseInt(event.target.value);
                    _offer.driverMainBirthDate = addYears(startDate, -_offer.driverMainAge);
                    break;
                }
                case "driverYoungSeniority": {
                    var startDate = _offer.startDate != null ? _offer.startDate : new Date();
                    _offer.driverYoungSeniority = parseInt(event.target.value);
                    _offer.driverYoungSeniorityDate = addYears(startDate, -_offer.driverYoungSeniority);
                    break;
                }
                case "driverMainSeniority": {
                    var startDate = _offer.startDate != null ? _offer.startDate : new Date();
                    _offer.driverMainSeniority = parseInt(event.target.value);
                    _offer.driverMainSeniorityDate = addYears(startDate, -_offer.driverMainSeniority);
                    break;
                }

            }


            return _offer;
        });




        // setOfferData(name, event);

        // const data = offer;
        // var startDate = data.startDate != null ? data.startDate : new Date();

        // var age = parseInt(event.target.value);

        // if (age >= 0) {
        //     // 
        //     var year = startDate.getFullYear() - age;

        //     var dateName = "";
        //     var dateName2 = "";
        //     var dateName3 = "";

        //     switch (name) {
        //         case "driverYoungAge": dateName = "driverYoungBirthDate"; dateName2 = "driverMainBirthDate"; dateName3 = "driverMainAge"; break;
        //         case "driverMainAge": dateName = "driverMainBirthDate"; break;
        //         case "driverYoungSeniority": dateName = "driverYoungSeniorityDate"; dateName2 = "driverMainSeniorityDate"; dateName3 = "driverMainSeniority"; break;
        //         case "driverMainSeniority": dateName = "driverMainSeniorityDate"; break;
        //     }




        //     var curDate = startDate;//new Date();
        //     console.log('setDriverAge year', year)

        //     setOfferData(dateName, new Date(year, curDate.getMonth(), curDate.getDate()));
        //     setOfferData(dateName + "Manual", true);

        //     if (offer != null && offer.authorizedToDrive == AuthorizedToDrive._2 && clalMainFill == false && dateName2 != "") {
        //         setOfferData(dateName2, new Date(year, curDate.getMonth(), curDate.getDate()));
        //         setOfferData(dateName2 + "Manual", true);

        //         setOfferData(dateName3, event);
        //     }


        // }

    }

    const setFCW = async () => {
        const data = offer;
        if (data.vehicle != null) {
            data.vehicle.fcw = !data.vehicle.fcw;
            setOffer(data);
        }
    }

    const setESP = async () => {
        const data = offer;
        if (data.vehicle != null) {
            data.vehicle.esp = !data.vehicle.esp;
            setOffer(data);
        }
    }

    const setLDW = async () => {
        const data = offer;
        if (data.vehicle != null) {
            data.vehicle.ldw = !data.vehicle.ldw;
            setOffer(data);
        }
    }



    const getVehicleDetails = async () => {
        var licenseNumber = offer?.vehicle?.licenseNumber;
        if (licenseNumber) {

            if (licenseNumber && licenseNumber.length > 0) {
                setVehicleDetailsError("");
                setEntryToRoadDateError("");
                setManufacturerError("");
                setVehicleModelError("");
                setVehicleSubModelError("");
                clearVehicleData();
            }

            if (licenseNumber.length > 0 && licenseNumber.length >= 7 && lastLicense != licenseNumber) {
                setLastLicense(licenseNumber);

                setVehicleDetails(new VehicleDetailsData());

                try {
                    setLicenseNumberLoading(true);
                    var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(licenseNumber);



                    if (data != null) {
                        const vehicle: VehicleDetailsData = new VehicleDetailsData();

                        if (data.LeviItzhak != null) {

                            if (!offer.vehicle) {
                                offer.vehicle = new VehicleDataModel();

                            }

                            if (offer.vehicle) {
                                debugger;
                                offer.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                                offer.vehicle.carYear = data.LeviItzhak.carYear;
                                vehicle.carYear = data.LeviItzhak.carYear;
                                offer.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
                                offer.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel?.val;
                                if (data.LeviItzhak.manufacturer != null) {

                                    vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;
                                    vehicle.manufacturer = data.LeviItzhak.manufacturer.label;
                                    vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;

                                }
                                if (data.LeviItzhak.vehicleModel != null) {

                                    vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val
                                    vehicle.vehicleModel = data.LeviItzhak.vehicleModel.label;

                                    vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                                }

                                if (data.LeviItzhak.vehicleSubModel != null) {

                                    vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                                    vehicle.vehicleSubModel = data.LeviItzhak.vehicleSubModel.label;
                                    vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;

                                    vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                                    vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
                                    vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                                    vehicle.degemCd = data.LeviItzhak.degemCd;

                                    setVehicleDetails(vehicle);

                                }


                                offer.vehicle.esp = data.LeviItzhak.esp;
                                offer.vehicle.fcw = data.LeviItzhak.fcw;
                                offer.vehicle.ldw = data.LeviItzhak.ldw;


                                if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code > 0)) {
                                    setMissingVehicleDetails(true);
                                    setShowVehicleDetails(true);
                                    setVehicleDetailsError(data.LeviItzhak.error.message);
                                }
                                else {
                                    setMissingVehicleDetails(false);
                                    setShowVehicleDetails(false);
                                }

                            }


                        }

                        setLicenseNumberLoading(false);

                    }

                    setOffer(prev => {
                        const _offer = new SimulatorOfferModel(prev);
                        if (_offer.vehicle)
                            _offer.vehicle.licenseNumber = licenseNumber;
                        return _offer;
                    });



                } catch (error) {
                    setVehicleDetailsError("מספר הרכב או פרטי הרכב אינם תקינים")

                    console.log(error);
                }
            }
            else {
                //this.clearVehicleData();
            }
        }
    }


    const clearVehicleData = async () => {

        const _vehicle = offer.vehicle;
        if (_vehicle) {
            _vehicle.id = undefined;
            _vehicle.modelCode = "";
            _vehicle.automaticInd = true;
            _vehicle.carYear = new Date().getFullYear();
            _vehicle.vehicleSubModelId = "";


            setVehicleDetails(new VehicleDetailsData());


        }

        setOffer(prev => {
            const _offer = new SimulatorOfferModel(prev);

            _offer.vehicleId = undefined;
            _offer.vehicle = _vehicle;
            return _offer;
        })
    }

    const setLicenseNumber = (event: any) => {
        setOffer(prev => {
            const _offer = new SimulatorOfferModel(prev);

            if (!_offer.vehicle)
                _offer.vehicle = new VehicleDataModel();
            if (event.currentTarget)
                _offer.vehicle.licenseNumber = event.target.value;
            else {
                _offer.vehicle.licenseNumber = event.target.value;
            }
            return _offer;
        });




    }


    const loadModelCode = async (search: string) => {
        if (search && search.length >= 3) {
            setModelcodeAutocomplete(await new SimulatorModel().getModelCode(search));
        }
        setModelCode(search);
    }

    const selectModelCode = async (id: string) => {

        if (id != null && id.length > 0) {


            if (id) {
                var data = await new SimulatorModel().getVehicleDetails(id);

                setVehicleDetails(new VehicleDetailsData());
                setModelCode(data.vehicleSubModel.code);


                const modelCodes: any[] = ModelcodeAutocomplete as any[];
                const modelCode = modelCodes.find(model => model.value == id);

                if (modelCode) {
                    const code = modelCode.text.split(' - ')[0];
                    const data = await getModelDataByCode(code, "");

                }
            } else {
                setModelCode("");

            }

        }


    }

    const getModelDataByCode = async (code: string, licenseNumber: string) => {

        if (vehicleDetails && vehicleDetails.vehicleSubModelId != null && vehicleDetails.vehicleSubModelId != "")
            return;

        if (code.length > 0 && lastmodelCode != code) {
            setCodeModelLoading(true);
            setLastmodelCode(code);


            setVehicleDetailsError("");
            setEntryToRoadDateError("");
            setManufacturerError("");
            setVehicleModelError("");
            setVehicleSubModelError("");
            setVehicleDetails(new VehicleDetailsData());

            let data: any = null;
            const vehicle: VehicleDetailsData = new VehicleDetailsData();
            const _offer = offer;
            try {
                data = await new SimulatorModel().getModelDetailsByModelCode(code, licenseNumber);

                if (data != null) {


                    if (data.LeviItzhak != null) {
                        vehicle.modelCode = code;
                        if (!_offer.vehicle)
                            _offer.vehicle = new VehicleDataModel();

                        if (_offer.vehicle) {
                            _offer.vehicleOwnership = data.LeviItzhak.vehicleOwnership;

                            if (licenseNumber == null || licenseNumber.length == 0) {
                                _offer.vehicle.carYear = data.LeviItzhak.carYear;
                                vehicle.carYear = data.LeviItzhak.carYear;
                                _offer.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
                            }
                            if (data.LeviItzhak.manufacturer != null) {
                                vehicle.manufacturerId = data.LeviItzhak.manufacturer.val
                                vehicle.manufacturer = data.LeviItzhak.manufacturer.label;
                                vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;

                            }
                            if (data.LeviItzhak.vehicleModel != null) {

                                vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val
                                vehicle.vehicleModel = data.LeviItzhak.vehicleModel.label;

                                vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                            }

                            if (data.LeviItzhak.vehicleSubModel != null) {

                                vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val
                                vehicle.vehicleSubModel = data.LeviItzhak.vehicleSubModel.label;
                                vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;

                                vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                                vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                                vehicle.degemCd = data.LeviItzhak.degemCd;



                            }
                            _offer.vehicle.esp = data.LeviItzhak.esp;
                            _offer.vehicle.fcw = data.LeviItzhak.fcw;
                            _offer.vehicle.ldw = data.LeviItzhak.ldw;


                            if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code > 0)) {
                                setMissingVehicleDetails(true);
                                setShowVehicleDetails(true);



                            }
                            else {
                                setMissingVehicleDetails(false);
                                setShowVehicleDetails(true);

                            }
                        }


                    }
                    setLicenseNumberLoading(false);
                }
                if (!_offer.vehicle)
                    _offer.vehicle = new VehicleDataModel();


                _offer.vehicle.licenseNumber = licenseNumber;
                setOffer(_offer);
                setVehicleDetails(vehicle);
                setCodeModelLoading(false);




            } catch (error) {

            }
            return data;

        }
    }

    const setCheckboxStateData = (name: keyof SimulatorOfferModel, event: any) => {
        setOffer(prev => {

            // Create a new instance of the class using the previous data
            const updated = new SimulatorOfferModel(prev);

            (updated as any)[name] = event.target.checked;

            return updated;
        });
    }

    const setEntryToRoadDate = (name: string, value: any) => {
        setOffer(prev => {

            // Create a new instance of the class using the previous data
            const updated = new SimulatorOfferModel(prev);
            if (updated && updated.vehicle)
                updated.vehicle.entryToRoadDate = value;


            return updated;
        });

    }

    const loadManufacturer = async (search: string) => {
        const dataAll = await ManufacturerAll;

        setManufacturerAutocomplete(dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1)
        );

        setManufacturer(search);
    }

    const selectManufacturer = async (event: any) => {
        var id = event.target.id;
        var value = event.target.innerHTML;
        var data = await new SimulatorModel().getVehicleModelByManufactureOrSearch(undefined, id);

        setVehicleModelAll(data);

        setManufacturer(value);
        setVehicleModel("");
        setVehicleModelId("");
        setVehicleSubModel("");
        setVehicleSubModelId("");
        setModelCode("");
        setVehicleModelAutocomplete(data);
    }

    const loadVehicleModel = async (search: string) => {

        const dataAll = VehicleModelAll;

        setVehicleModelAutocomplete(dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1));

        setVehicleModel(search);

    }

    const selectVehicleModel = async (event: any) => {
        var id = event.target.id;
        var value = event.target.innerHTML;
        var data = await new SimulatorModel().getVehicleSubModelByVehicleModelOrSearch(undefined, id);
        setVehicleSubModelAll(data);
        setVehicleModel(value);
        setVehicleModelId(id);
        setVehicleSubModel("");
        setVehicleSubModelId("");
        setModelCode("");
        setVehicleSubModelAutocomplete(data);
    }

    const loadVehicleSubModel = async (search: string) => {

        const dataAll = VehicleSubModelAll;

        setVehicleSubModelAutocomplete(dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1));

        setVehicleSubModel(search);
    }

    const selectVehicleSubModel = async (event: any) => {
        selectModelCode(event);
    }
    const openPopup = async () => {
        if (localStorage.getItem("isAdminUser") == "true")
            await setShowVehiclePopup(true);

    }

    const hasValue = (value?: string | number | null) => {
        if (!value && value !== 0) return "";
        return `${value} `;
    }

    const updateRider = (updatedRider: RiderPackageModel) => {

        const leadRider = new LeadRider({
            riderPackageId: updatedRider.id,
            price: updatedRider.recommendedCost
        });
        if (updatedRider.autoActive == null || updatedRider.autoActive == YesNo._1) {
            setOffer(prev => {
                const _offer = new SimulatorOfferModel(prev);

                const riders = _offer.riders ?? [];

                let activeRiders = riders.filter(r => r.riderPackageId !== leadRider.riderPackageId);

                _offer.riders = activeRiders;

                return _offer;
            });
        }
        else {
            setOffer(prev => {
                const _offer = new SimulatorOfferModel(prev);

                const riders = _offer.riders ?? [];

                const exists = riders.some(
                    r => r.riderPackageId === leadRider.riderPackageId
                );

                _offer.riders = exists
                    ? riders.map(r =>
                        r.riderPackageId === leadRider.riderPackageId
                            ? leadRider
                            : r
                    )
                    : [...riders, leadRider];

                return _offer;
            });
        }


    };


    const driverTypeMap = {
        [AuthorizedToDrive._0]: "נהג אחד",
        [AuthorizedToDrive._1]: "שני נהגים",
        [AuthorizedToDrive._2]: "כל נהג",
    };

    return (<>
        <div className="popup-wrapper RenewalOfferPopup">
            <section className="popup-window new-renewal rtl">
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title"> עדכון מחיר חידוש
                        </div>

                    </div>

                    <div className="container">
                        <div className="box"><div className="popup-body">
                            <div className="tab-contents">
                                <div className="tab-content tab-content-1 selected">
                                    <section className="simulator-form simulator-form1">
                                        {renewal && renewal.policy ? (<>

                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        חברה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.route?.insuranceCompany ? renewal.policy.policyAdditionDetails.route.insuranceCompany.name : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מסלול
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            {renewal.policy?.policyAdditionDetails?.route ? renewal.policy.policyAdditionDetails.route.comment : ""}
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        מחיר קסקו
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {renewal.policy.policyAdditionDetails ? renewal.policy.policyAdditionDetails.premiumSum : ""}


                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מחיר חובה
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            {renewal.compulsoryPolicy?.policyAdditionDetails ? renewal.compulsoryPolicy.policyAdditionDetails.premiumSum : ""}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מחיר ריידרים
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">
                                                            {renewal.rider?.riderPackages ? renewal.rider.riderPackages.reduce((sum, rider) => sum + (rider.customerCost || 0), 0) : ""}

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        סוג ביטוח
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">

                                                            {InsuranceTypes && renewal.policy?.policyAdditionDetails?.vehiclePolicyType ? getNameByIdInIDNameDescriptionDictionary(InsuranceTypes, renewal.policy.policyAdditionDetails.vehiclePolicyType) : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        תאריך התחלה
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            {renewal.policy.startDate ? moment(new Date(renewal.policy.startDate)).format('DD/MM/YYYY') : ""}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="cell endDate error-message-parent">
                                                    <div>
                                                        תאריך סיום
                                                    </div>
                                                    <div className='filter-input'>
                                                        {renewal.policy.endDate ? moment(new Date(renewal.policy.endDate)).format('DD/MM/YYYY') : ""}
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div className='parameter-row address-row'>
                                                        <div className="parameter-item" key="city">
                                                            <div className="field">
                                                                <div className="title">עיר</div>
                                                                <div className="value">

                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].city : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item" key="street">
                                                            <div className="field">
                                                                <div className="title">רחוב</div>
                                                                <div className="value">
                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].street : ""}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item" key="house">
                                                            <div className="field">
                                                                <div className="title">מס בית</div>
                                                                <div className="value">
                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].houseNumber : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='parameter-row address-row'>
                                                        <div className="parameter-item" key="city">
                                                            <div className="field">
                                                                <div className="title">כניסה</div>
                                                                <div className="value">

                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].entry : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item" key="street">
                                                            <div className="field">
                                                                <div className="title">
                                                                    ת.ד.</div>
                                                                <div className="value">
                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].mailbox : ""}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item" key="house">
                                                            <div className="field">
                                                                <div className="title">מס דירה</div>
                                                                <div className="value">
                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].apartmentNumber : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='parameter-row address-row'>
                                                        <div className="parameter-item" key="city">
                                                            <div className="field">
                                                                <div className="title">קומה</div>
                                                                <div className="value">


                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item" key="street">
                                                            <div className="field">
                                                                <div className="title">
                                                                    מיקוד</div>
                                                                <div className="value">
                                                                    {renewal.policy.customer?.customerAddresses != null && renewal.policy.customer.customerAddresses.length > 0 ? renewal.policy.customer.customerAddresses[0].postalCode : ""}

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        נהגים
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {AuthorizedToDrive &&
                                                                renewal.policy?.policyAdditionDetails?.driversType !== undefined
                                                                ? driverTypeMap[renewal.policy.policyAdditionDetails.driversType] || ""
                                                                : ""}


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div>
                                                <div className={renewal.policy?.policyAdditionDetails?.driversType && (renewal.policy?.policyAdditionDetails?.driversType == AuthorizedToDrive._1 || renewal.policy?.policyAdditionDetails?.driversType === AuthorizedToDrive._2) ? "row-title" : "hide"}>
                                                    הנהג הצעיר
                                                </div>

                                                <div className={renewal.policy?.policyAdditionDetails?.driversType && (renewal.policy?.policyAdditionDetails?.driversType == AuthorizedToDrive._1 || renewal.policy?.policyAdditionDetails?.driversType === AuthorizedToDrive._2) ? "simulator-row" : "hide"}>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            גיל
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            {renewal.policy?.policyAdditionDetails?.driverYoungAge}


                                                        </div>

                                                    </div>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            שנות ותק
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            {renewal.policy?.policyAdditionDetails?.driverYoungSeniority}


                                                        </div>

                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מגדר
                                                        </div>
                                                        <div className="filter-input">
                                                            {Geder && renewal.policy?.policyAdditionDetails?.driverYoungGender ? getNameByIdInIDNameDescriptionDictionary(Geder, renewal.policy?.policyAdditionDetails?.driverYoungGender) : ""}


                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סטטוס
                                                        </div>
                                                        <div className="filter-input">
                                                            {MaritalStatus && renewal.policy?.policyAdditionDetails?.driverYoungMaritalStatus ? getNameByIdInIDNameDescriptionDictionary(MaritalStatus, renewal.policy?.policyAdditionDetails?.driverYoungMaritalStatus) : ""}



                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div>
                                                <div className={renewal.policy?.policyAdditionDetails?.driversType && (renewal.policy?.policyAdditionDetails?.driversType == AuthorizedToDrive._1 || renewal.policy?.policyAdditionDetails.driversType as AuthorizedToDrive === AuthorizedToDrive._0) ? "row-title" : "hide"}>
                                                    הנהג העיקרי
                                                </div>


                                                <div className={renewal.policy?.policyAdditionDetails?.driversType && (renewal.policy?.policyAdditionDetails?.driversType == AuthorizedToDrive._1 || renewal.policy?.policyAdditionDetails.driversType as AuthorizedToDrive === AuthorizedToDrive._0) ? "simulator-row" : "hide"} >
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            גיל
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            {renewal.policy?.policyAdditionDetails?.driverMainAge}

                                                        </div>

                                                    </div>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            שנות ותק
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            {renewal.policy?.policyAdditionDetails?.driverMainSeniority}
                                                        </div>

                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מגדר
                                                        </div>
                                                        <div className="filter-input">
                                                            {Geder && renewal.policy?.policyAdditionDetails?.driverMainGender ? getNameByIdInIDNameDescriptionDictionary(Geder, renewal.policy?.policyAdditionDetails?.driverMainGender) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סטטוס
                                                        </div>
                                                        <div className="filter-input">
                                                            {MaritalStatus && renewal.policy?.policyAdditionDetails?.driverMainMaritalStatus ? getNameByIdInIDNameDescriptionDictionary(MaritalStatus, renewal.policy?.policyAdditionDetails?.driverMainMaritalStatus) : ""}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="row-title">רכב</div>
                                                <div className="flex-centered flex-space-between">
                                                    <div className={`car-type ${offer != null && renewal.policy?.policyAdditionDetails?.vehicle && renewal.policy?.policyAdditionDetails?.vehicle.esp ? "black" : ""}`} >ESP</div>
                                                    <div className={`car-type ${offer != null && renewal.policy?.policyAdditionDetails?.vehicle && renewal.policy?.policyAdditionDetails?.vehicle.fcw ? "black" : ""}`} >FCW</div>
                                                    <div className={`car-type ${offer != null && renewal.policy?.policyAdditionDetails?.vehicle && renewal.policy?.policyAdditionDetails?.vehicle.ldw ? "black" : ""}`} >LDW</div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        מספר רכב
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.licenseNumber}
                                                        </div>
                                                        <div className='error-message'>{vehicleDetailsError}</div>

                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        קוד דגם
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">

                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.vehicleSubModel?.modelCode}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        אוטומטי?
                                                    </div>
                                                    <div>
                                                        <div className="">
                                                            <input type="checkbox" disabled checked={renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.automaticInd ? renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.automaticInd : true} />


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        שנה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.carYear}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        ת.ע. לכביש
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.entryToRoadDate ? moment(new Date(renewal.policy?.policyAdditionDetails?.vehicle?.entryToRoadDate)).format('DD/MM/YYYY') : ""}


                                                        </div>
                                                        <div className='error-message'>{entryToRoadDateError}</div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        יצרן
                                                    </div>

                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">

                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.vehicleSubModel?.vehicleModel?.manufacturer?.name}
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        דגם
                                                    </div>
                                                    <div className='error-message-parent'>

                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.vehicleSubModel?.vehicleModel?.name}
                                                        </div>
                                                        <div className='error-message'>{vehicleModelError}</div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        תת דגם
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.vehicle?.vehicleSubModel?.name}
                                                        </div>
                                                        <div className='error-message'>{vehicleSubModelError}</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div className="row-title">
                                                            עבר ביטוחי
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סוג ביטוח
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מספר תביעות
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            שנה אחרונה
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">


                                                            {PassedTypeOfInsurance && renewal.policy?.policyAdditionDetails?.passedInsuranceTypeLastYear ? getNameByIdInIDNameDescriptionDictionary(PassedTypeOfInsurance, renewal.policy?.policyAdditionDetails?.passedInsuranceTypeLastYear) : ""}



                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.sueNumber1}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני שנתיים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance && renewal.policy?.policyAdditionDetails?.passedInsuranceType2YearsAgo ? getNameByIdInIDNameDescriptionDictionary(PassedTypeOfInsurance, renewal.policy?.policyAdditionDetails?.passedInsuranceType2YearsAgo) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.sueNumber2}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני 3 שנים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance && renewal.policy?.policyAdditionDetails?.passedInsuranceType3YearsAgo ? getNameByIdInIDNameDescriptionDictionary(PassedTypeOfInsurance, renewal.policy?.policyAdditionDetails?.passedInsuranceType3YearsAgo) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.sueNumber3}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני 4 שנים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance && renewal.policy?.policyAdditionDetails?.passedInsuranceType4YearsAgo ? getNameByIdInIDNameDescriptionDictionary(PassedTypeOfInsurance, renewal.policy?.policyAdditionDetails?.passedInsuranceType4YearsAgo) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.sueNumber4}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div className='small-title'>
                                                            תביעות גוף
                                                        </div>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.bodyClaimsAmount}
                                                        </div>
                                                    </div>

                                                    <div className="cell ">
                                                        <div className='small-title'>
                                                            שלילות
                                                        </div>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.revocationsAmount}
                                                        </div>
                                                    </div>
                                                    <div className="cell noInsuranceDiv">
                                                        <div>
                                                            <input disabled type="checkbox" checked={renewal.policy?.policyAdditionDetails?.noInsurance ? renewal.policy?.policyAdditionDetails?.noInsurance : false} />
                                                            מבוטח ללא עבר ביטוחי
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="simulator-row">
                                                <div className="row-title">פרטים נוספים והרחבות</div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        בעלות הרכב
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {VehicleOwnership && renewal.policy?.policyAdditionDetails?.vehicle?.vehicleOwnership ? getNameByIdInIDNameDescriptionDictionary(VehicleOwnership, renewal.policy?.policyAdditionDetails?.vehicle?.vehicleOwnership) : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        ה.ע. בירידת ערך
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">

                                                            {ImpairmentDeductible && renewal.policy?.policyAdditionDetails?.deductible ? getNameByIdInIDNameDescriptionDictionary(ImpairmentDeductible, renewal.policy?.policyAdditionDetails?.deductible) : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        חידוש במ. הסוכן
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {"מגדל"}


                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        חידוש בחברה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="simulator-row">
                                                    <div className="cell checkbox">
                                                        <div>

                                                            <input disabled type="checkbox" checked={renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.mainVehicle ? renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.mainVehicle : true} />
                                                        </div>
                                                        <div>
                                                            משמש כרכב עיקרי
                                                        </div>
                                                    </div>
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input disabled type="checkbox" checked={renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.autodirection ? renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.autodirection : true} />


                                                        </div>
                                                        <div>
                                                            כינון אוטומטי
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell checkbox">
                                                        <div>

                                                            <input disabled type="checkbox" checked={renewal.policy?.policyAdditionDetails?.drivingOnShabbat ? renewal.policy?.policyAdditionDetails?.drivingOnShabbat : true} />

                                                        </div>
                                                        <div>
                                                            הרכב נוסע בשבת
                                                        </div>
                                                    </div>
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input disabled type="checkbox" checked={renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.newForOld ? renewal.policy?.policyAdditionDetails?.elementaryPolicy?.offer?.newForOld : true} />
                                                        </div>
                                                        <div>
                                                            חדש תמורת ישן
                                                        </div>
                                                    </div>
                                                </div>

                                                {policyRiderPackages ? <div className="form-table-row flex-space-between flex-centered">
                                                    <div className="form-table-column">
                                                        <div className="title">
                                                            חבילה
                                                        </div>

                                                    </div>
                                                    <div className="form-table-column">
                                                        <div className="title">
                                                            עלות
                                                        </div>

                                                    </div>
                                                </div> : ""}

                                                {policyRiderPackages && policyRiderPackages.length > 0 ? policyRiderPackages.map((rider: RiderPackageModel) => {
                                                    return (
                                                        <>
                                                            <OfferRider checked={true} rider={rider} onChanged={() => { }}></OfferRider>
                                                        </>
                                                    )
                                                }) : ""}





                                            </div>

                                        </>) : (
                                            <p>loading...</p>
                                        )}







                                    </section>

                                </div>
                            </div>
                        </div></div>
                        <div className="box"><div className="popup-body">
                            <div className="tab-contents">
                                <div className="tab-content tab-content-1 selected">
                                    <section className="simulator-form simulator-form1">
                                        {renewal ? (<>

                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        חברה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {renewal.policy?.policyAdditionDetails?.route?.insuranceCompany ? renewal.policy.policyAdditionDetails.route.insuranceCompany.name : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מסלול
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            {renewal.policy?.policyAdditionDetails?.route ? renewal.policy.policyAdditionDetails.route.comment : ""}
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        מחיר קסקו
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            <input type="number" className='smallInput' id="cascoPremium" onChange={(e: any) => setOfferData("cascoPremium", e.target.value)} value={offer != null ? offer.cascoPremium : ""} />


                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מחיר חובה
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            <input type="number" className='smallInput' id="compulsoryPremium" onChange={(e: any) => setOfferData("compulsoryPremium", e.target.value)} value={offer != null ? offer.compulsoryPremium : ""} />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        מחיר ריידרים
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">
                                                            {offer != null && offer.riders ? offer.riders.reduce((sum, rider) => sum + (rider.price || 0), 0) : ""}

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                            <div className="simulator-row">
                                                <div className="cell ">
                                                    <div>
                                                        סוג ביטוח
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {InsuranceTypes ? (<IDNameDescriptionItemSelect OnChange={setRenewalData} Id={"InsuranceType"}

                                                                Options={InsuranceTypes} Value={offer != null && offer.insuranceType ? offer.insuranceType : undefined} />
                                                            ) : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        תאריך התחלה
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input startDateSelectDiv">

                                                            <CompDatePicker value={offer.startDate} id='startDate' onChange={(date: Date) => { setOfferData("startDate", date); calcEndDate(); }} />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="cell endDate error-message-parent">
                                                    <div>
                                                        תאריך סיום
                                                    </div>
                                                    <div className='filter-input'>
                                                        <CompDatePicker value={offer.endDate} id='endDate' onChange={(date: Date) => setRenewalData("endDate", date)} />

                                                    </div>

                                                </div>
                                            </div>

                                            <div className="simulator-row">
                                                <div className="cell">                                                                                        
                                                    <Address CustomerAddress={offer != null && offer.involvedAddress ? offer.involvedAddress : new CustomerAddress()} addressChange={changeAddress} rows={3}></Address>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        נהגים
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {AuthorizedToDrive ? (<IDNameDescriptionItemSelect OnChange={setAuthorizedToDrive}
                                                                Id={"authorizedToDrive"} Options={AuthorizedToDriveList} Value={offer != null ? offer.authorizedToDrive : undefined} />
                                                            ) : ""}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div>
                                                <div className={offer != null && offer.authorizedToDrive && (offer.authorizedToDrive == AuthorizedToDrive._1 || offer.authorizedToDrive == AuthorizedToDrive._2) ? "row-title" : "hide"}>
                                                    הנהג הצעיר
                                                </div>

                                                <div className={offer != null && offer.authorizedToDrive && (offer.authorizedToDrive == AuthorizedToDrive._1 || offer.authorizedToDrive == AuthorizedToDrive._2) ? "simulator-row" : "hide"}>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            גיל
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            <input type="number" className='smallInput' id="driverYoungAge" onChange={(e: any) => setDriverAge("driverYoungAge", e)} value={offer != null ? offer.driverYoungAge : ""} />
                                                            <DatePicker
                                                                ref={driverYoungAgeRef}
                                                                selected={offer.driverYoungBirthDate ? new Date(offer.driverYoungBirthDate) : undefined}
                                                                onSelect={(e: any) => setDriverDate("driverYoungBirthDate", e)}
                                                                onChange={(e: any) => setDriverDate("driverYoungBirthDate", e)}
                                                                showTimeInput={false}
                                                                showYearDropdown
                                                                dateFormatCalendar="MMMM"
                                                                yearDropdownItemNumber={15}
                                                                scrollableMonthYearDropdown
                                                                useShortMonthInDropdown
                                                            />
                                                            <div className="icon calendar" onClick={(e: any) => { if (driverYoungAgeRef.current != null) driverYoungAgeRef.current.setOpen(true) }}></div>


                                                        </div>

                                                    </div>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            שנות ותק
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            <input type="number" className='smallInput' id="driverYoungSeniority" onChange={(e: any) => setDriverAge("driverYoungSeniority", e)} value={offer != null ? offer.driverYoungSeniority : ""} />
                                                            <DatePicker
                                                                ref={driverYoungSeniorityDateRef}
                                                                selected={offer.driverYoungSeniorityDate ? new Date(offer.driverYoungSeniorityDate) : undefined}
                                                                onSelect={(e: any) => setDriverDate("driverYoungSeniorityDate", e)}
                                                                onChange={(e: any) => setDriverDate("driverYoungSeniorityDate", e)}
                                                                showTimeInput={false}
                                                                showYearDropdown
                                                                dateFormatCalendar="MMMM"
                                                                yearDropdownItemNumber={15}
                                                                scrollableMonthYearDropdown
                                                                useShortMonthInDropdown
                                                            />

                                                            <div className="icon calendar" onClick={(e: any) => { if (driverYoungSeniorityDateRef.current != null) driverYoungSeniorityDateRef.current.setOpen(true) }}></div>

                                                        </div>

                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מגדר
                                                        </div>
                                                        <div className="filter-input">
                                                            {Geder ? (<IDNameDescriptionItemSelect OnChange={setDriverDate} Id={"driverYoungGender"} Options={Geder} Value={offer != null ? offer.driverYoungGender : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סטטוס
                                                        </div>
                                                        <div className="filter-input">
                                                            {MaritalStatus ? (<IDNameDescriptionItemSelect OnChange={setDriverDate} Id={"driverYoungMaritalStatus"} Options={MaritalStatus} Value={offer != null ? offer.driverYoungMaritalStatus : undefined} />
                                                            ) : ""}


                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div>
                                                <div className={offer != null && (offer.authorizedToDrive == AuthorizedToDrive._1 || offer.authorizedToDrive == AuthorizedToDrive._0) ? "row-title" : "hide"}>
                                                    הנהג העיקרי
                                                </div>


                                                <div className={offer != null && (offer.authorizedToDrive == AuthorizedToDrive._1 || offer.authorizedToDrive == AuthorizedToDrive._0) ? "simulator-row" : "hide"} >
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            גיל
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            <input type="number" id="driverMainAge" onChange={(e: any) => setDriverAge("driverMainAge", e)} value={offer != null ? offer.driverMainAge : ""} />

                                                            <DatePicker
                                                                ref={driverMainAgeRef}
                                                                selected={offer && offer.driverMainBirthDate ? new Date(offer.driverMainBirthDate) : undefined}
                                                                onSelect={(e: any) => setDriverDate("driverMainBirthDate", e)}
                                                                onChange={(e: any) => setDriverDate("driverMainBirthDate", e)}
                                                                showTimeInput={false}
                                                                showYearDropdown
                                                                dateFormatCalendar="MMMM"
                                                                yearDropdownItemNumber={15}
                                                                scrollableMonthYearDropdown
                                                                useShortMonthInDropdown
                                                            />
                                                            <div className="icon calendar" onClick={(e: any) => { if (driverMainAgeRef.current != null) driverMainAgeRef.current.setOpen(true) }}></div>

                                                        </div>

                                                    </div>
                                                    <div className="cell error-message-parent">
                                                        <div>
                                                            שנות ותק
                                                        </div>
                                                        <div className="filter-input ageSeniorityCalendar">
                                                            <input type="number" id="driverMainSeniority" onChange={(e: any) => setDriverAge("driverMainSeniority", e)} value={offer != null ? offer.driverMainSeniority : ""} />
                                                            <DatePicker
                                                                ref={driverMainSeniorityDateRef}
                                                                selected={offer != null && offer.driverMainSeniorityDate ? new Date(offer.driverMainSeniorityDate) : undefined}
                                                                onSelect={(e: any) => setDriverDate("driverMainSeniorityDate", e)}
                                                                onChange={(e: any) => setDriverDate("driverMainSeniorityDate", e)}
                                                                showTimeInput={false}
                                                                showYearDropdown
                                                                dateFormatCalendar="MMMM"
                                                                yearDropdownItemNumber={15}
                                                                scrollableMonthYearDropdown
                                                                useShortMonthInDropdown
                                                            />

                                                            <div className="icon calendar" onClick={(e: any) => { if (driverMainSeniorityDateRef.current != null) driverMainSeniorityDateRef.current.setOpen(true) }}></div>

                                                        </div>

                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מגדר
                                                        </div>
                                                        <div className="filter-input">
                                                            {Geder ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"driverMainGender"} Options={Geder} Value={offer != null ? offer.driverMainGender : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סטטוס
                                                        </div>
                                                        <div className="filter-input">
                                                            {MaritalStatus ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"driverMainMaritalStatus"} Options={MaritalStatus} Value={offer != null ? offer.driverMainMaritalStatus : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="row-title">רכב</div>
                                                <div className="flex-centered flex-space-between">
                                                    <div onClick={(e: any) => setESP()} className={`car-type ${offer != null && offer.vehicle && offer.vehicle.esp ? "black" : ""}`} >ESP</div>
                                                    <div onClick={(e: any) => setFCW()} className={`car-type ${offer != null && offer.vehicle && offer.vehicle.fcw ? "black" : ""}`} >FCW</div>
                                                    <div onClick={(e: any) => setLDW()} className={`car-type ${offer != null && offer.vehicle && offer.vehicle.ldw ? "black" : ""}`} >LDW</div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        מספר רכב
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">
                                                            <input type="text" value={offer && offer.vehicle ? offer.vehicle.licenseNumber : ""} id='licenseNumber' onChange={(e: any) => setLicenseNumber(e)}
                                                            /*onKeyDown={(e: any) => {if (e.key === 'Enter') {getVehicleDetails(e);}}}*/ onBlur={getVehicleDetails}
                                                                disabled={vehicleDetails != null && vehicleDetails.modelCode != null ? true : false}
                                                            />
                                                            <img src={require("../assets/images/loading.gif")} className={licenseNumberLoading ? "loadingGif" : "hide"} />
                                                        </div>
                                                        <div className='error-message'>{vehicleDetailsError}</div>

                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        קוד דגם
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">

                                                            <Autocomplete Value={vehicleDetails != null ? vehicleDetails.modelCode : ""} Id="modelCode"
                                                                ClassName=''
                                                                OnChange={loadModelCode}
                                                                OnSelect={selectModelCode}
                                                                OnBlur={getModelDataByCode}
                                                                DataList={ModelcodeAutocomplete}
                                                                Disabled={offer && offer.vehicle && offer.vehicle.modelCode && offer.vehicle.modelCode != "" ? true : false}
                                                            />
                                                            <img src={require("../assets/images/loading.gif")} className={codeModelLoading ? "loadingGif" : "hide"} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        אוטומטי?
                                                    </div>
                                                    <div>
                                                        <div className="">
                                                            <input onChange={(e: any) => setCheckboxStateData("automaticInd", e)} type="checkbox" checked={offer && offer.automaticInd != null ? offer.automaticInd : true} />


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        שנה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            <DynamicSelect ClassName="" OnChange={setOfferData} Value={offer && offer.vehicle ? offer.vehicle.carYear : ""} Options={CarYear != null ? CarYear.map((x: string) => ({ Text: x, Value: x })) : []} Id={"carYear"} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        ת.ע. לכביש
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">


                                                            <CompDatePicker value={offer && offer.vehicle ? offer.vehicle.entryToRoadDate : undefined} onChange={(date: Date) => setEntryToRoadDate("vehicle.entryToRoadDate", date)} />

                                                        </div>
                                                        <div className='error-message'>{entryToRoadDateError}</div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        יצרן
                                                    </div>

                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">

                                                            <Autocomplete Value={vehicleDetails != null ? vehicleDetails.manufacturer : ""} Id="manufacturer"
                                                                ClassName=''
                                                                OnChange={loadManufacturer}
                                                                OnSelect={selectManufacturer}
                                                                DataList={ManufacturerAutocomplete}
                                                                Disabled={offer && offer.vehicle && offer.vehicle.modelCode && offer.vehicle.modelCode != "" ? true : false}
                                                            />
                                                        </div>
                                                        <div className='error-message'>{manufacturerError}</div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        דגם
                                                    </div>
                                                    <div className='error-message-parent'>

                                                        <div className="filter-input">
                                                            <Autocomplete Value={vehicleDetails != null && vehicleDetails.vehicleModel ? vehicleDetails.vehicleModel : ""} Id="vehicleModel"
                                                                ClassName=''
                                                                OnChange={loadVehicleModel}
                                                                OnSelect={selectVehicleModel}
                                                                DataList={VehicleModelAutocomplete}
                                                                Disabled={offer && offer.vehicle && offer.vehicle.modelCode && offer.vehicle.modelCode != "" ? true : false}

                                                            />
                                                        </div>
                                                        <div className='error-message'>{vehicleModelError}</div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        תת דגם
                                                    </div>
                                                    <div className='error-message-parent'>
                                                        <div className="filter-input">
                                                            <Autocomplete Value={vehicleDetails != null && vehicleDetails.vehicleSubModel ? vehicleDetails.vehicleSubModel : ""} Id="vehicleSubModel"
                                                                ClassName=''
                                                                OnChange={loadVehicleSubModel}
                                                                OnSelect={selectVehicleSubModel}
                                                                DataList={VehicleSubModelAutocomplete}
                                                                Disabled={offer && offer.vehicle && offer.vehicle.modelCode && offer.vehicle.modelCode != "" ? true : false}

                                                            />
                                                        </div>
                                                        <div className='error-message'>{vehicleSubModelError}</div>
                                                    </div>
                                                </div>
                                                {offer && offer.vehicle && offer.vehicle.modelCode && offer.vehicle.modelCode != "" ? "" :
                                                    <div className={"parameter-row"}><div className={showVehicleDetails ? (missingVehicleDetails ? "editRed" : "edit") : "hide"} onClick={(e: any) => openPopup()} ><FontAwesomeIcon icon={faPenToSquare} /></div></div>
                                                }
                                            </div>
                                            <div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div className="row-title">
                                                            עבר ביטוחי
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            סוג ביטוח
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div>
                                                            מספר תביעות
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            שנה אחרונה
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"passedTypeOfInsurance1"} Options={PassedTypeOfInsurance} Value={offer != null ? offer.passedTypeOfInsurance1 : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            <input type="number" id="sueNumber1" onChange={(e: any) => setOfferData("sueNumber1", e.target.value)} value={offer != null ? offer.sueNumber1 : ""} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני שנתיים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"passedTypeOfInsurance2"} Options={PassedTypeOfInsurance} Value={offer != null ? offer.passedTypeOfInsurance2 : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            <input type="number" id="sueNumber2" onChange={(e: any) => setOfferData("sueNumber2", e.target.value)} value={offer != null ? offer.sueNumber2 : ""} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני 3 שנים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"passedTypeOfInsurance3"} Options={PassedTypeOfInsurance} Value={offer != null ? offer.passedTypeOfInsurance3 : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            <input type="number" id="sueNumber3" onChange={(e: any) => setOfferData("sueNumber3", e.target.value)} value={offer != null ? offer.sueNumber3 : ""} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div>
                                                            לפני 4 שנים
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            {PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"passedTypeOfInsurance4"} Options={PassedTypeOfInsurance} Value={offer != null ? offer.passedTypeOfInsurance4 : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                    <div className="cell">
                                                        <div className="filter-input">
                                                            <input type="number" id="sueNumber4" onChange={(e: any) => setOfferData("sueNumber4", e.target.value)} value={offer != null ? offer.sueNumber4 : ""} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell">
                                                        <div className='small-title'>
                                                            תביעות גוף
                                                        </div>
                                                        <div className="filter-input">
                                                            <input type="number" id="bodyClaimsAmount" onChange={(e: any) => setOfferData("bodyClaimsAmount", e.target.value)} value={offer != null ? offer.bodyClaimsAmount : ""} />
                                                        </div>
                                                    </div>

                                                    <div className="cell ">
                                                        <div className='small-title'>
                                                            שלילות
                                                        </div>
                                                        <div className="filter-input">
                                                            <input type="number" id="revocationsAmount" onChange={(e: any) => setOfferData("revocationsAmount", e.target.value)} value={offer != null ? offer.revocationsAmount : ""} />
                                                        </div>
                                                    </div>
                                                    <div className="cell noInsuranceDiv">
                                                        <div>
                                                            <input onChange={(e: any) => setOfferData("noInsurance", e)} type="checkbox" checked={offer != null ? offer.noInsurance : false} />
                                                            מבוטח ללא עבר ביטוחי
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="simulator-row">
                                                <div className="row-title">פרטים נוספים והרחבות</div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        בעלות הרכב
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {VehicleOwnership ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"vehicleOwnership"} Options={VehicleOwnership} Value={offer != null ? offer.vehicleOwnership : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        ה.ע. בירידת ערך
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {ImpairmentDeductible ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"impairmentDeductible"} Options={ImpairmentDeductible} Value={offer != null ? offer.impairmentDeductible : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simulator-row">
                                                <div className="cell">
                                                    <div>
                                                        חידוש במ. הסוכן
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {RenovationAgentsOffice ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"renovationAgentsOffice"} Options={RenovationAgentsOffice} Value={offer != null ? offer.renovationAgentsOffice : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cell">
                                                    <div>
                                                        חידוש בחברה
                                                    </div>
                                                    <div>
                                                        <div className="filter-input">
                                                            {RenovationCompany ? (<IDNameDescriptionItemSelect OnChange={setOfferData} Id={"renovationCompany"} Options={RenovationCompany} Value={offer != null ? offer.renovationCompany : undefined} />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="simulator-row">
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input onChange={(e: any) => setCheckboxStateData("mainVehicle", e)} type="checkbox" checked={offer != null ? offer.mainVehicle : false} />

                                                        </div>
                                                        <div>
                                                            משמש כרכב עיקרי
                                                        </div>
                                                    </div>
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input onChange={(e: any) => setCheckboxStateData("autodirection", e)} type="checkbox" checked={offer != null ? offer.autodirection : false} />

                                                        </div>
                                                        <div>
                                                            כינון אוטומטי
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="simulator-row">
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input onChange={(e: any) => setCheckboxStateData("driveInShabbat", e)} type="checkbox" checked={offer != null ? offer.driveInShabbat : true} />

                                                        </div>
                                                        <div>
                                                            הרכב נוסע בשבת
                                                        </div>
                                                    </div>
                                                    <div className="cell checkbox">
                                                        <div>
                                                            <input onChange={(e: any) => setCheckboxStateData("newForOld", e)} type="checkbox" checked={offer != null ? offer.newForOld : false} />

                                                        </div>
                                                        <div>
                                                            חדש תמורת ישן
                                                        </div>
                                                    </div>
                                                </div>

                                                {offer.riders ? <div className="form-table-row flex-space-between flex-centered">
                                                    <div className="form-table-column">
                                                        <div className="title">
                                                            חבילה
                                                        </div>

                                                    </div>
                                                    <div className="form-table-column">
                                                        <div className="title">
                                                            עלות
                                                        </div>

                                                    </div>
                                                </div> : ""}
                                                {riderPackages && riderPackages.length > 0 ? riderPackages.map((rider: RiderPackageModel) => {
                                                    return (
                                                        <>
                                                            <OfferRider recommendedCost={offer.riders && offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id).length > 0 ? offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id)[0].price : undefined} checked={offer.riders && offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id).length > 0} rider={rider} onChanged={(x: RiderPackageModel) => updateRider(x)}></OfferRider>
                                                        </>
                                                    )
                                                }) : ""}



                                            </div>

                                        </>) : (
                                            <p>loading...</p>
                                        )}







                                    </section>

                                </div>
                            </div>
                        </div></div>
                    </div>




                    <div className="popup-footer">
                        <button className="button white blue-border" onClick={(e: any) => closePopup()}>
                            ביטול
                        </button>
                        <button className="button blue" onClick={(e: any) => saveOffer()}>
                            שמירה
                        </button>
                    </div>
                </div>



            </section>
        </div>






    </>
    );
}


export default RenewalOfferPopup
